import api from 'api';

export const loadRequestedBy = api(
  'GET /api/gallery-concepts/fields/requested-by'
);

export const loadApplications = api(
  'GET /api/gallery-concepts/fields/applications'
);
export const loadTags = api('GET /api/gallery-concepts/fields/tags');

export const loadSimilarConcepts = api(
  'POST /api/gallery-concepts/fields/similar'
);
export const loadConceptFamilies = api(
  'GET /api/gallery-concepts/fields/concept-families'
);
export const loadBusinessPartners = api(
  'GET /api/gallery-concepts/fields/business-partners'
);
export const loadAllBusinessPartners = api(
  'GET /api/gallery-concepts/fields/all-business-partners'
);
export const loadPromoCodes = api(
  'POST /api/gallery-concepts/fields/promo-codes'
);
export const loadPromoCode = api(
  'GET /api/gallery-concepts/fields/promo-codes/:id'
);
export const loadChannels = api('GET /api/gallery-concepts/fields/channels');
export const loadLanguages = api('GET /api/gallery-concepts/fields/languages');
export const loadEnhancers = api('GET /api/gallery-concepts/fields/enhancers');
export const loadOutsourceStudios = api(
  'GET /api/gallery-concepts/fields/outsource-studios'
);
export const loadAuthors = api('GET /api/gallery-concepts/fields/authors');
export const loadProductionTypes = api(
  'GET /api/gallery-concepts/fields/production-types'
);
